import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "utils/interface.utils";


const initialState: UserState = {
    currentUser: {
        _id: null,
        email: null,
        name: null,
    }
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<UserState>) => {
            state.currentUser = action.payload.currentUser;
        },

        clearUser: (state) => {
            state.currentUser = {
                _id: null,
                email: null,
                name: null,
            }
        }
    }
})

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;